import { makeStyles } from 'tss-react/mui'
import { nunito_sans } from '@styles/fonts'
import { pxToRem } from '@styles/function'

const useStyles = makeStyles()((theme) => ({
  root: {},
  selectWrapper: {
    '& .Mui-selected': {
      fontFamily: nunito_sans.style.fontFamily,
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: pxToRem(20),
      lineHeight: pxToRem(27),
      textAlign: 'center',
      letterSpacing: '0.02em',
      textTransform: 'uppercase',
      color: '#000000 !important',
      [theme.breakpoints.down('md')]: {
        fontSize: '16px',
      },
    },
  },
  tabsIndicator: {
    background: '#000000',
    height: '4px',
    textDecoration: 'underline',
    transition: '.3s ease-in-out',
    [theme.breakpoints.down('md')]: {
      height: '3px',
    },
  },
  tab: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: pxToRem(20),
    lineHeight: pxToRem(27),
    marginLeft: theme.spacing(2),
    textAlign: 'center',
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
    color: 'rgba(49, 49, 49, 0.8)',
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
    },
  },

  videoCard: {
    cursor: 'pointer',
  },

  hideOnSm: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
    ul: {
      li: {
        button: {
          background: 'transparent',
        },
      },
    },
  },
  shortsPlayerContainer: {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(2, 2, 2, 0.9)',
    backdropFilter: 'blur(12.8px)',
  },
}))

export default useStyles
